import ReactDOM from 'react-dom/client';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import './index.css';
import reportWebVitals from './reportWebVitals';
import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import App from './routes/App';
import '@fontsource/poppins/300.css';

import '@fontsource/poppins/400.css';
import '@fontsource/poppins/700.css';
import CognitoProtected from './components/CognitoProtected';
import { CognitoAuthProvider } from './contexts/CognitoAuthContext';

import Dashboard from './routes/dashboard/Dashboard';
import Drivers from './routes/drivers/Drivers';
import AppSetup from './routes/appSetup/AppSetup';
import ConfigProvider from './contexts/ConfigContext';
import { TestUsersProvider } from './contexts/TestUsersContext';
import { NotInWhiteListUsersProvider } from './contexts/NotInWhiteListUsersContext';
import { NotCustomerUsersProvider } from './contexts/NotCustomerUsersContext';
import { DemoModeProvider } from './contexts/DemoModeContext';
import Trips from './routes/trips/Trips';
import DeviceStatusSummary from './routes/device-status-summary/DeviceStatusSummary';
import Alerts from './routes/alerts/Alerts';
import AppCustomisation from './routes/app-customisation/AppCustomisation';
import Features from './routes/app-customisation/features/Features';
import LookAndFeel from './routes/app-customisation/look-and-feel/LookAndFeel';
import StoreConfiguration from './routes/app-customisation/store-configuration/StoreConfiguration';
import Fonts from './routes/app-customisation/look-and-feel/fonts/Fonts';
import Logo from './routes/app-customisation/look-and-feel/logo/Logo';
import Links from './routes/app-customisation/look-and-feel/links/Links';
import Emails from './routes/app-customisation/look-and-feel/emails/Emails';
import WhiteListRegistration from './routes/app-customisation/white-list-registration/WhiteListRegistration';
import Profile from './routes/profile/Profile';
import Colours from './routes/app-customisation/look-and-feel/colours/Colours';
import Icon from './routes/app-customisation/look-and-feel/icon/Icon';
import Splash from './routes/app-customisation/look-and-feel/splash/Splash';
import Reward from './routes/app-customisation/look-and-feel/reward/Reward';
import RewardNavigation from './routes/app-customisation/look-and-feel/rewardNavigation/RewardNavigation';
import EmptyBag from './routes/app-customisation/look-and-feel/emptyBag/EmptyBag';
import FullBag from './routes/app-customisation/look-and-feel/fullBag/FullBag';
import LoginBg from './routes/app-customisation/look-and-feel/loginBg/LoginBg';
import Images from './routes/app-customisation/look-and-feel/images/Images';
import TripDetail from './routes/trip-detail/TripDetail';

Chart.register(ChartDataLabels);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ConfigProvider>
      <TestUsersProvider>
        <NotInWhiteListUsersProvider>
          <NotCustomerUsersProvider>
            <BrowserRouter>
              <CognitoAuthProvider>
                <CognitoProtected>
                  <DemoModeProvider>
                    <Routes>
                      <Route path="/" element={<App />}>
                        <Route index element={<Dashboard />} />
                        <Route path="/app-setup" element={<AppSetup />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/drivers" element={<Drivers />} />
                        <Route path="/trips" element={<Trips />} />
                        <Route
                          path="/device-status-summary"
                          element={<DeviceStatusSummary />}
                        />
                        <Route path="/alerts" element={<Alerts />} />
                        <Route path="/user/:userId" element={<Profile />} />
                        <Route
                          path="/user/:userId/trip/:tripId"
                          element={<TripDetail />}
                        />
                        <Route
                          path="/app-customisation"
                          element={<AppCustomisation />}
                        >
                          <Route index path="features" element={<Features />} />
                          <Route
                            path="store-configuration"
                            element={<StoreConfiguration />}
                          />
                          <Route
                            path="white-list-registration"
                            element={<WhiteListRegistration />}
                          />
                          <Route path="look-and-feel" element={<LookAndFeel />}>
                            <Route index element={<Colours />} />
                            <Route path="fonts" element={<Fonts />} />
                            <Route path="images" element={<Images />} />
                            <Route path="icon" element={<Icon />} />
                            <Route path="reward" element={<Reward />} />
                            <Route path="emptyBag" element={<EmptyBag />} />
                            <Route
                              path="rewardNavigation"
                              element={<RewardNavigation />}
                            />
                            <Route path="loginBg" element={<LoginBg />} />
                            <Route path="fullBag" element={<FullBag />} />
                            <Route path="logo" element={<Logo />} />
                            <Route path="splash" element={<Splash />} />
                            <Route path="links" element={<Links />} />
                            <Route path="emails" element={<Emails />} />
                          </Route>
                        </Route>
                      </Route>
                    </Routes>
                  </DemoModeProvider>
                </CognitoProtected>
              </CognitoAuthProvider>
            </BrowserRouter>
          </NotCustomerUsersProvider>
        </NotInWhiteListUsersProvider>
      </TestUsersProvider>
    </ConfigProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
